import { Loader2, Truck } from "lucide-react";
import { useDriverVehicle } from "../../hooks/useDriverPortal";

const DOC_LABELS = { rc: "RC", insurance: "Insurance", permit: "Permit", puc: "PUC", fitness: "Fitness Certificate" };

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

function Row({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderTop: "1px solid #F3F4F6", fontSize: 13.5 }}>
      <span style={{ color: "#9CA3AF" }}>{label}</span>
      <span style={{ color: "#111827", fontWeight: 600 }}>{value || "—"}</span>
    </div>
  );
}

export default function DriverVehicle() {
  const { data, loading } = useDriverVehicle();

  if (loading) {
    return (
      <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader2 size={18} style={{ animation: "spin 1s linear infinite", color: "#9CA3AF" }} />
      </main>
    );
  }

  return (
    <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB" }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "28px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", marginBottom: 2 }}>My Vehicle</div>
        <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>View only — your fleet owner manages assignment and details</div>

        {!data?.vehicle ? (
          <div style={{ background: "#fff", border: "1px dashed #D1D5DB", borderRadius: 14, padding: "48px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: "#374151" }}>No vehicle has been assigned by your fleet owner.</div>
          </div>
        ) : (
          <>
            <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "18px 20px", marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: "#EEF2FF", color: "#4F46E5", display: "flex", alignItems: "center", justifyContent: "center" }}><Truck size={20} /></div>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>{data.vehicle.nickname}</div>
                  <div style={{ fontSize: 12.5, color: "#6B7280" }}>{data.vehicle.plateNumber} · {data.vehicle.type}</div>
                </div>
              </div>
              <Row label="Registration Number" value={data.vehicle.plateNumber} />
              <Row label="Owner Name" value={data.vehicle.ownerName} />
              <Row label="Owner Contact" value={data.vehicle.contactNumber} />
            </div>

            <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "18px 20px" }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#111827", marginBottom: 8 }}>Documents</div>
              {data.vehicle.documents?.length ? data.vehicle.documents.map((d, i) => (
                <Row key={i} label={DOC_LABELS[d.docType] || d.docType} value={fmtDate(d.expiryDate)} />
              )) : <div style={{ fontSize: 13, color: "#9CA3AF" }}>No documents on file.</div>}
            </div>
          </>
        )}
      </div>
    </main>
  );
}
